$(function () {

    $('#referralLinkCopy').on('click', function (e) {
        var copyTextarea = $('#referralLink');
        copyTextarea.focus();
        copyTextarea.select();

        try { document.execCommand('copy'); } catch (e) {}
    });

});